import React from 'react';
import * as S from './AboutMe.styles';

import perfil from '../../Components/Images/perfil2.png';
import SocialIcons from '../../Components/SocialNetworks/SocialIcons';

const AboutMe = () => {
  return (
    <S.ContainerAboutMe id="start">
      <S.ContainerFlex>
        <S.ContainerText>
          <S.Title>
            <p> Hello, I'm </p>
            <p> Itzabelli</p>
            <p> Frontend Developer</p>
          </S.Title>

          <S.DescriptionText>
            <span id="description">Let me help you with your project </span>
          </S.DescriptionText>

          <SocialIcons />
        </S.ContainerText>
        <S.ContainerImage>
          <img src={perfil} alt="Itzabelli - Frontend Developer" />
        </S.ContainerImage>
      </S.ContainerFlex>
    </S.ContainerAboutMe>
  );
};

export default AboutMe;
